import script from "./MonthlyReportPreCreateButtonArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthlyReportPreCreateButtonArea.vue?vue&type=script&setup=true&lang=ts"

import "./MonthlyReportPreCreateButtonArea.vue?vue&type=style&index=0&id=19e870a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e870a6"]])

export default __exports__